<template>
    <div id="Captcha">
        <mu-flex ref="button" @click="openCaptcha" class="Captcha" justify-content="center" align-items="center">
            <template v-if="captchaResult == 'process'">
                <mu-button fab small><mu-icon value="beenhere" :size="14"></mu-icon></mu-button>
                <span>{{$t('register.click_registe')}}</span>
            </template>
            <template v-else-if="captchaResult == 'success'">
                <mu-button fab small color="green"><mu-icon value="check" :size="14"></mu-icon></mu-button>
                <span style="color:#4caf50;">{{$t('register.check_pass')}}</span>
            </template>
            <template v-else>
                <mu-button fab small><mu-icon value="beenhere" :size="14"></mu-icon></mu-button>
                <span>{{$t('register.click_registe')}}</span>
            </template>
        </mu-flex>
        <mu-flex direction="column" v-if="showCaptcha" class="captcha_content" :class="showCaptcha? '':'hide_captcha'">
            <div ref="captcha" id="captcha"></div>
        </mu-flex>
        <div class="full_screen_blank" v-if="showCaptcha" @click="showCaptcha = false"></div>
    </div>
</template>
<script>
import "@/utils/slideBlock.js";

export default {
    name: "Captcha",
    data() {
        return {
            showCaptcha:false,
            captchaResult: 'process'
        }
    },
    props: {
        resultCallBack: Function
    },
    mounted () {
        
    },
    methods: {
        openCaptcha() {
            if (this.captchaResult == 'success') {
                return;
            }
            console.log("open captcha");
            this.showCaptcha = !this.showCaptcha;
            var self = this;
            setTimeout(() => {
                self.getCaptcha();
            }, 200);
        },
        getCaptcha() {
            var self = this;
            console.log(self.$refs.captcha);
            jigsaw.init({
                el: self.$refs.captcha,
                onSuccess: self.captchaSuccess,
                onFail: self.captchaFail,
                onRefresh: self.captchaClean
            });
        },
        captchaSuccess() {
            console.log("成功");
            var self = this;
            this.resultCallBack(true);
            this.captchaResult = 'success';
            setTimeout(() => {
                self.showCaptcha = false
            }, 400);
        },
        captchaFail() {
            console.log("失败");
            this.resultCallBack(false);
            this.captchaResult = 'fail';
            setTimeout(() => {
                jigsaw.refresh();
            }, 400);
        },
        captchaClean() {
            console.log("刷新");
        },
    }
}
</script>
<style scoped>
@import "../assets/css/slideBlock.css";
#Captcha {
    position: relative;
    width: 90%;
    margin:0px 5%;
}
.Captcha {
    position: relative;
    cursor: pointer;
    padding:8px 0px;
    width: 100%;
    background:#f1f3f5;
    border:1px solid #eee;
    /* box-shadow: 0 2px 4px 2px rgba(40, 120, 255, 0.1),
        0 2px 4px 2px rgba(0, 0, 0, 0.05); */
}
.Captcha:hover {
    opacity: 0.7;
}
.Captcha .mu-button {
    width:24px;
    height:24px;
    border-radius: 24px;
}
.Captcha span {
    color:#333333;
    margin-left:8px;
    font-size:12px;
}
.captcha_content {
    position: absolute;
    z-index: 2;
    padding:4px 0px;
    left:0px;
    bottom:0px;
    width:100%;
    background:#f1f3f5;
    border:1px solid #eee;
    display:flex;
    opacity: 1;
    transition: all 0.3s ease-in-out;
    box-shadow: 0 2px 4px 2px rgba(40, 120, 255, 0.1),
        0 2px 4px 2px rgba(0, 0, 0, 0.05);
}
.hide_captcha {
    display:none;
    opacity: 0;
    transition: all 0.3s ease-in-out;
}
.full_screen_blank {
    width:100vw;
    height:100vh;
    top:0px;
    left:0px;
    position: fixed;
    z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/Captcha.vue